import {
  Table, TableBody, TableCell, TableHead, TableRow, Typography, Box, Button, Chip, Pagination
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

export default function OrdersPage() {
  const STATUS_MAP: Record<string, { label: string; color: any }> = {
    NEW: { label: 'Новый', color: 'info' },
    SUCCESS: { label: 'Выполнен', color: 'success' },
    CLOSE: { label: 'Закрыт', color: 'error' },
  };

  const [orders, setOrders] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const fetchOrders = (page: number) => {
    api.get(`/api/admin/orders?page=${page}&limit=10`)
      .then(res => {
        setOrders(res.data.data);
        setPages(res.data.pages);
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchOrders(page);
  }, [page]);

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Заказы</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>id заказа</TableCell>
            <TableCell>Имя</TableCell>
            <TableCell>Дата</TableCell>
            <TableCell>Доставка</TableCell>
            <TableCell>Сумма</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map(order => (
            <TableRow key={order._id}>
              <TableCell>{order._id}</TableCell>
              <TableCell>{order.name}</TableCell>
              <TableCell>{new Date(order.createdAt).toLocaleString()}</TableCell>
              <TableCell>{order.deliveryMethod === 'courier' ? 'Доставка' : 'Самовывоз'}</TableCell>
              <TableCell>{order.items.reduce((sum: number, i: any) => sum + (i.price * (i.count ?? 4) || 0), 0)} ₽</TableCell>
              <TableCell>
                <Chip
                  label={STATUS_MAP[order.status]?.label || order.status}
                  color={STATUS_MAP[order.status]?.color || 'default'}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Button variant="outlined" component={Link} to={`/orders/${order._id}`}>
                  Посмотреть
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box display="flex" justifyContent="center" mt={3}>
        <Pagination
          count={pages}
          page={page}
          onChange={(_, value) => setPage(value)}
          color="primary"
        />
      </Box>
    </Box>
  );
}
